import { render, staticRenderFns } from "./NavItemList.vue?vue&type=template&id=43be4da1&"
import script from "./NavItemList.vue?vue&type=script&lang=ts&"
export * from "./NavItemList.vue?vue&type=script&lang=ts&"
import style0 from "./NavItemList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports